import { Box, useMediaQuery, useTheme } from '@mui/material';

import { useChatBubble } from '@/hooks/useChatBubble';
import { AIChatBubble } from './AIChatBubble';
import { GuidedTutorialPanel } from './GuidedTutorialPanel';
import { HelpModeToggle } from './HelpModeToggle';

/** Chat FAB size must match AIChatBubble styled button (56 mobile / 60 desktop). */
const FAB_SIZE_MOBILE = 56;
const FAB_SIZE_DESKTOP = 60;
const STACK_GAP = 8;
const TOGGLE_APPROX_HEIGHT = 44;
const PANEL_GAP = 8;

/**
 * Stacks Guided help toggle above the AI chat bubble; shows GuidedTutorialPanel when enabled.
 * Hidden on profile routes (same visibility as chat — see useChatBubble).
 */
export const FloatingAssistantDock = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const { isVisible } = useChatBubble();

  if (!isVisible) return null;

  const side = theme.spacing(isMobile ? 2 : 3);
  const fabSize = isMobile ? FAB_SIZE_MOBILE : FAB_SIZE_DESKTOP;

  const bottomPx = isMobile ? 16 : 24;
  const toggleBottomPx = bottomPx + fabSize + STACK_GAP;
  const panelBottomPx = toggleBottomPx + TOGGLE_APPROX_HEIGHT + PANEL_GAP;

  return (
    <>
      <GuidedTutorialPanel bottomOffsetPx={panelBottomPx} />
      <Box
        sx={{
          position: 'fixed',
          right: side,
          bottom: toggleBottomPx,
          zIndex: 1000,
        }}
      >
        <HelpModeToggle />
      </Box>
      <AIChatBubble />
    </>
  );
};
